import { createContext, useContext, useEffect, useState } from "react"
import AppConfig from "../models/AppConfig";
import { fetchClientAppCustomData } from '../api/repositoryEP';
import LoadingPage from "../pages/Commons/LoadingPage/LoadingPage";

export const availableAppLanguages: Array<string> = ['es', 'us', 'mx', 'pt', 'en', 'fr'];

const defaultconfigValues: AppConfig = {
    web: "",
    chainName: "",
    hasRewardsContracted: false,
    hasVerificationCode: false,
    mainColor: "black",
    secondaryColor: "black",
    scripts: [],
    widget: {
        searchTheme: "dark",
        mainColor: "white",
        secondaryColor: "black",
        availableRoomTypes: ['individual', 'double', 'multiple'],
        maxGuestsPerRoom: 4,
        maxAdultsPerRoom: 4,
        maxChildrenPerRoom: 4,
        minGuestsPerRoom: 1,
        maxRooms: 10,
        minRooms: 1,

    },
    dateFormat: "DD/MM/YYYY",
    availableLanguages: [],
    siteName: '',
    legalTexts: {
        legalWarning: '',
        privacity: '',
        cookies: '',
        termsAndConditions: ''
    },
    images: {
        brandLogo: "",
        appLogo: "",
        loginBackGround: ""
    },
    availableUserTypes: [],
    availableCurrencies: [],
    prefixNames: [],
    customRegisterFields: [],
    hotels: [],
    contactPhones: [],
    contactFormParameters: {
        release: 1,
        minRoomsNumber: 1,
        maxRoomsNumber: 1,
        minOccupancyNumber: 1,
        maxOccupancyNumber: 1,
        availableBugetTypes: [],
        availableServices: [],
        sendCopyToAgent: false,
        mailTo: ""
    },
    currenciesExchange: [],
    clientData: {
        id: "",
        name: "",
        identifyCode: ""
    },
    regimes: [],
    rooms: [],
    servicesAvailable: [],
    userCommissionConfiguration: []
};

const AppConfigContext = createContext<{
    config: AppConfig,
    setConfig: React.Dispatch<React.SetStateAction<AppConfig>>, // <-- esto es nuevo
    device: 'mobile' | 'tablet' | 'desktop'
}>({
    config: defaultconfigValues,
    setConfig: () => { }, // valor por defecto
    device: 'desktop'
});

export const AppConfigProvider: React.FC<{ children: React.ReactNode, responsive: 'mobile' | 'tablet' | 'desktop' }> = ({ children, responsive }) => {

    const [config, setConfig] = useState<AppConfig>(defaultconfigValues);
    const [device, setDevice] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const loadConfig = async () => {
            setIsReady(false);
            // Espera un pequeño tiempo por si App.tsx aún está guardando los datos
            let retries = 0;
            let configInSessionStorage = sessionStorage.getItem("app-config");

            while ((!configInSessionStorage || configInSessionStorage === '{}') && retries < 10) {
                await new Promise(res => setTimeout(res, 100)); // espera 100ms
                configInSessionStorage = sessionStorage.getItem("app-config");
                retries++;
            }

            if (configInSessionStorage && configInSessionStorage !== '{}') {
                setConfig(JSON.parse(configInSessionStorage));
            } else {
                // fallback a fetch si no hay nada en storage
                const urlParams = new URLSearchParams(window.location.search);
                const t = urlParams.get('t');
                try {
                    const sessionData = sessionStorage.getItem("user-data");
                    const userId = sessionData ? JSON.parse(sessionData).userData?.id : "";
                    const response = await fetchClientAppCustomData(!!t, true, userId);
                    if (response?.data) {
                        setConfig(response.data as AppConfig);
                        sessionStorage.setItem("app-config", JSON.stringify(response.data));
                    }
                } catch (e) {
                    console.error("Error fetching client app config:", e);
                }
            }
            setIsReady(true);
        };
        loadConfig();
    }, []);

    useEffect(() => {
        if (config.chainName) {
            document.title = config.chainName;

        }
    }, [config]);


    useEffect(() => {
        setDevice(responsive);
    }, [responsive])

    return (
        <AppConfigContext.Provider value={{ config, setConfig, device }}>
            {!isReady ? <LoadingPage /> : children}
        </AppConfigContext.Provider>
    )

}

export const useAppConfig = (): { config: AppConfig, setConfig: React.Dispatch<React.SetStateAction<AppConfig>>, device: 'mobile' | 'tablet' | 'desktop' } => {
    return useContext(AppConfigContext);
}